// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2fS57";
export var contain = "footer-module--contain--1Mo7S";
export var contact = "footer-module--contact--16s89";
export var email = "footer-module--email--1iiAd";
export var copyright = "footer-module--copyright--hhCzN";
export var split = "footer-module--split--2t6Nb";
export var weChat = "footer-module--weChat--2CChZ";
export var weChatDesc = "footer-module--weChatDesc--cu46X";
export var back = "footer-module--back--3MGzT";